import {css, html} from '@isceco/widget-library2/external/lit'
import '@isceco/widget-library2/basic-elements/NumberInput/NumberInput.js'
import '@isceco/widget-library2/basic-elements/Form/Form.js'
import '@isceco/widget-library2/basic-elements/ModalDialog/ModalDialog.js'
import '@isceco/widget-library2/basic-elements/Textarea/Textarea.js'
import WebComponent from '../../../WebComponent.js'
import I18n from '../../../i18n.js'
import AngebotService from "./AngebotService";
import Angebot from "./Angebot";
import AuthorizationFilter from "../../Authorization/AuthorizationFilter";

export default class AngebotEgo extends WebComponent {

  static VISPSEA_DIALOG = 'angebot-vispsea-dialog';

  static get EVENT_KEYS() {
    return {
      RELOAD_TRIGGERED: 'angebot-ego-reload-triggered'
    }
  }

  get css() {
    return css`
      isceco-number-input {
        text-align: left !important;
      }

      .grid-container {
        display: grid;
        grid-template-columns: 0.3fr repeat(5, 1fr) repeat(2, 0.5fr);
      }

      .grid-item {
        padding: 0 7px 5px 7px;
        text-align: center;
        position: relative;
        min-width: 150px;
        border-right: 1px solid var(--isceco-color-grey-700)
      }

      .grid-item-two-last {
        padding: 0 7px 5px 7px;
        text-align: center;
        position: relative;
        min-width: 75px;
      }

      .grid-item-two-last:not(:nth-child(2n)) {
        border-right: 1px solid var(--isceco-color-grey-700);
      }

      .flex {
        display: flex;
      }

      .span {
        font-size: 0.8em;
      }

      .date-header {
        padding: 0 7px 5px 7px;
      }

      .subheader {
        width: 50%;
        font-size: 0.8em
      }

      .date {
        text-align: right;
        margin: 0 5px;
        display: flex;
        justify-content: center;
        align-self: center;
      }

      .vispSea {
        display: flex;
        flex-direction: row;
        height: 100%;
        margin-top: 2px;
        margin-left: 15px;
        color: var(--isceco-color-grey-900);
      }

      .vispSea > div {
        align-content: center;
      }

      .vispSeaEdit {
        margin-left: auto;
      }

      .vispSeaEdit > i {
        font-size: 1em !important;
      }

      .vispSeaInput {
        padding-top: 10px;
      }
    `
  }

  get translationFile() {
    return './views/Admin/Angebot/i18n.json'
  }

  constructor() {
    super()
    this.angebotService = new AngebotService()
    this.data = {}
    this.nextUrl = ''
    this.startDate = ''
    this.vispSeaDate = ''
    this.vispSeaType = ''
    this.isAdmin = AuthorizationFilter._hasRoleAdmin()
  }

  connectedCallback() {
    super.connectedCallback()
    this.startDate = new Date(this.getAttribute('start-date'))

    this._refresh = () => {
      this._loadData()
    }
    document.addEventListener(I18n.EVENT_KEYS.CHANGE_LANGUAGE, this._refresh)
    document.addEventListener(Angebot.EVENT_KEYS.DATE_CHANGED, event => {
      this.startDate = event.detail.startDate;
      this._refresh()
    });

    this._loadData()
  }

  disconnectedCallback() {
    document.removeEventListener(I18n.EVENT_KEYS.CHANGE_LANGUAGE, this._refresh)
    document.removeEventListener(Angebot.EVENT_KEYS.DATE_CHANGED, this._refresh)
  }

  _loadData() {
    const startDateString = this.startDate.toISOString().split('T')[0];

    this.angebotService.getAngebot('ego', startDateString)
      .then(angebot => {
        this.data = angebot
        send(Angebot.EVENT_KEYS.RELOAD_TRIGGERED, {modDate: this.getModTime()})
        this.render()
      })
      .catch(_ => this.reload())
  }

  getTemplate() {
    return html`
      <isceco-form id="angebot-form"
                   prevent-navigation
                   @abort="${event => this.handleAbort(event)}">
        <div slot="form-elements">
          <div class="grid-container">
            <div class="date-header"></div>
            <div class="grid-item">${this.getHeader('Wallbach')}</div>
            <div class="grid-item">${this.getHeader('Oltingue')}</div>
            <div class="grid-item">${this.getHeader('Griespass')}</div>
            <div class="grid-item">${this.getHeader('Höchst')}</div>
            <div class="grid-item">${this.getHeader('Fallentor')}</div>
            <div class="grid-item-two-last">
              <p>VISP</p>
            </div>
            <div class="grid-item-two-last">
              <p>SEA</p>
            </div>
            <div></div>
            <div class="grid-item flex">${this.getSubHeaderGroup()}</div>
            <div class="grid-item flex">${this.getSubHeaderGroup()}</div>
            <div class="grid-item flex">${this.getSubHeaderGroup()}</div>
            <div class="grid-item flex">${this.getSubHeaderGroup()}</div>
            <div class="grid-item flex">${this.getSubHeaderGroup()}</div>
            <div class="grid-item-two-last">
              <span>+</span>
            </div>
            <div class="grid-item-two-last">
              <span>+/-</span>
            </div>

            <!-- Rows -->
            ${this.data.map((row, index) => html`
              <div id="date-${index}" class="date">${this.getFormatedDate(row.date)}</div>
              ${this.getGridRow(row, index)}
            `)}
          </div>
        </div>
      </isceco-form>
      <isceco-dialog
        id="${AngebotEgo.VISPSEA_DIALOG}"
        hidden
        header="${this.i18n.translate('admin.angebot.visp.dialog.title')}"
        confirm-button="${this.i18n.translate('admin.angebot.visp.dialog.confirm')}"
        cancel-button="${this.i18n.translate('admin.angebot.visp.dialog.cancel')}"
        @submit="${event => {
          this._saveVispSea(event)
        }}">
        <isceco-number-input name="vispsea-value"
                             class="vispSeaInput"
                             required
                             maximum-fraction-digits="1"
                             label="${this.i18n.translate('admin.angebot.visp.dialog.value.title')}:"
        ></isceco-number-input>
        <isceco-textarea name="vispsea-info"
                         class="vispSeaInput"
                         label="${this.i18n.translate('admin.angebot.visp.dialog.info.title')}:"
        ></isceco-textarea>
      </isceco-dialog>
      <isceco-dialog
        hidden
        header="${this.i18n.translate('admin.angebot.confirm.header')}"
        id="angebot-confirm-dialog"
        confirm-button="${this.i18n.translate('admin.angebot.confirm.confirm')}"
        cancel-button="${this.i18n.translate('admin.angebot.confirm.cancel')}"
        @submit="${confirmed => this._close(confirmed)}">
      </isceco-dialog>
      <isceco-dialog
        hidden
        header="${this.i18n.translate('admin.confirm.formhaschanges.dialog.titel')}"
        description="${this.i18n.translate('admin.confirm.formhaschanges.dialog.beschreibung')}"
        id="handle-form-has-changes-dialog"
        confirm-button="${this.i18n.translate('admin.confirm.formhaschanges.dialog.bestaetigen')}"
        cancel-button="${this.i18n.translate('admin.confirm.formhaschanges.dialog.abbrechen')}"
        @submit="${confirmed => this._close(confirmed)}">
      </isceco-dialog>
      <isceco-dialog id="abort-dialog"
                     hidden
                     header="${this.i18n.translate('admin.confirm.changes.dialog.titel')}"
                     description="${this.i18n.translate('admin.confirm.changes.dialog.beschreibung')}"
                     confirm-button="${this.i18n.translate('admin.confirm.changes.dialog.bestaetigen')}"
                     cancel-button="${this.i18n.translate('admin.confirm.changes.dialog.abbrechen')}"
                     @submit="${event => this.confirmAbort(event)}"
      ></isceco-dialog>
    `
  }

  getHeader(einspeisepunkt) {
    return html`
      <div>
        <p>${einspeisepunkt}</p>
      </div>
    `
  }

  getSubHeaderGroup() {
    return html`
      <div class="subheader">
        <span>${this.i18n.translate('admin.angebot.gebKapa.title')}</span>
      </div>
      <div class="subheader">
        <span>${this.i18n.translate('admin.angebot.einkuerzung.title')}</span>
      </div>
    `
  }

  getFormatedDate(date) {
    if (formatDate(date) === formatDate(new Date())) {
      return html`
        <div class="date"><em>${formatDate(date)} (Heute)</em></div>`
    }
    return html`
      <div class="date">${formatDate(date)}</div>`
  }

  getModTime() {
    const modDates = this.data.flatMap(obj => obj.modificationDate !== undefined ? [new Date(obj.modificationDate)] : [])
    if (Number.isNaN(Math.max(...modDates))) {
      return html`-`
    } else {
      return formatDateTime(Math.max(...modDates))
    }
  }

  getGridRow(day, index) {
    return html`
      <div class="grid-item">${this.getNumberInputs(index, 'wb', day.wbGeb, day.wb)}</div>
      <div class="grid-item">${this.getNumberInputs(index, 'olt', day.oltGeb, day.olt)}</div>
      <div class="grid-item">${this.getNumberInputs(index, 'grie', day.grieGeb, day.grie)}</div>
      <div class="grid-item">${this.getNumberInputs(index, 'hoe', day.hoeGeb, day.hoe)}</div>
      <div class="grid-item">${this.getNumberInputs(index, 'fall', day.fallGeb, day.fall)}</div>
      <isceco-link
        class="grid-item-two-last"
        title="${day.vispInfo}"
        name="visp-${index}"
        @click="${_ => {
          if (this.handleFormHasChanges() === false) {
            this.vispSeaType = 'visp'
            this.vispSeaDate = day.date
            const modal = document.getElementById(AngebotEgo.VISPSEA_DIALOG)
            modal.header = this.i18n.translate('admin.angebot.visp.dialog.title')
            modal.children[0].label = this.i18n.translate('admin.angebot.visp.dialog.value.title')
            modal.children[0].min = 0
            modal.children[0].value = day.visp
            modal.children[1].label = this.i18n.translate('admin.angebot.visp.dialog.info.title')
            modal.children[1].value = day.vispInfo
            modal.removeAttribute('hidden')
          }
        }}">
        <div class="vispSea">
          <div>${day.visp}</div>
          <div class="vispSeaEdit" title="${this.i18n.translate('admin.angebot.visp.edit.title')}">
            <i slot="wrapper" class="edit icon"></i>
          </div>
        </div>
      </isceco-link>
      <isceco-link
        class="grid-item-two-last"
        title="${day.seaInfo}"
        name="sea-${index}"
        @click="${_ => {
          if (this.handleFormHasChanges() === false) {
            this.vispSeaType = 'sea'
            this.vispSeaDate = day.date
            const modal = document.getElementById(AngebotEgo.VISPSEA_DIALOG)
            modal.header = this.i18n.translate('admin.angebot.sea.dialog.title')
            modal.children[0].label = this.i18n.translate('admin.angebot.sea.dialog.value.title')
            modal.children[0].min = ''
            modal.children[0].value = day.sea
            modal.children[1].label = this.i18n.translate('admin.angebot.sea.dialog.info.title')
            modal.children[1].value = day.seaInfo
            modal.removeAttribute('hidden')
          }
        }}">
        <div class="vispSea">
          <div class="${day.seaTotalValid ? '' : 'failure'}">${day.sea}</div>
          <div class="vispSeaEdit" title="${this.i18n.translate('admin.angebot.sea.edit.title')}">
            <i slot="wrapper" class="edit icon"></i>
          </div>
        </div>
      </isceco-link>
    `
  }

  getNumberInputs(index, einspeisepunkt, value1, value2) {
    return html`
      <div style="display: flex; gap: 10px;">
        <isceco-number-input name="${einspeisepunkt}-geb-${index}"
                             disabled
                             value="${value1}"></isceco-number-input>
        <isceco-number-input name="${einspeisepunkt}-${index}"
                             maximum-fraction-digits="1"
                             max="0"
                             min="-${value1}"
                             ?disabled="${!this.isAdmin}"
                             placeholder="0"
                             value="${value2}"
                             @change="${e => this.updateValue(index, einspeisepunkt, e)}"></isceco-number-input>
      </div>
    `
  }

  updateValue(index, einspeisepunkt, event) {
    this.data[index][einspeisepunkt] = +event.detail.value
  }

  _close(e) {
    e.target.hidden = true
    if (e.detail.confirmed) {
      this._save()
    }
  }

  _save() {
    this.angebotService.updateAngebot(this.data, 'ego')
      .then(() => {
        // Reset the valueChanged from the form inputs, data are already saved in another way
        const formElements = document.querySelector('#angebot-form').getFormElements();
        if (formElements) {
          formElements.forEach(element => {
            element.valueChanged = false
          })
        }
        showAlert(this.i18n.translate('admin.angebot.createupdate.success'), '', 'success')
        this._refresh()
      })
      .catch(() => {
        showAlert(this.i18n.translate('admin.angebot.createupdate.failure'), '', 'error')
        this.render()
      })
  }

  handleAbort = event => {
    const dialog = document.querySelector('#abort-dialog')
    dialog.hidden = false
    this.nextUrl = event.detail.url ?? '#Cockpit'
  }

  confirmAbort = event => {
    if (event.detail.confirmed) {
      navigate({to: this.nextUrl, allow: true})
    } else {
      event.target.hidden = true
    }
  }

  handleFormHasChanges = _ => {
    if (document.querySelector('#angebot-form').hasChanges() === true) {
      document.getElementById('handle-form-has-changes-dialog').removeAttribute('hidden')
      return true;
    }
    return false;
  }

  _saveVispSea(event) {
    const dialog = document.getElementById(AngebotEgo.VISPSEA_DIALOG);
    if (event.detail.confirmed === true) {
      const data = {
        type: this.vispSeaType,
        date: this.vispSeaDate
      }
      data[this.vispSeaType + 'Value'] = dialog.children[0].value
      data[this.vispSeaType + 'Info'] = dialog.children[1].value

      this.angebotService.updateAngebot(data, 'ego/vispSea')
        .then(result => {
          dialog.setAttribute('hidden', true)
          showAlert(this.i18n.translate('admin.angebot.createupdate.success'), '', 'success')
          if (result === false) {
            showAlert(this.i18n.translate('admin.angebot.createupdate.seaTotalInvalid'), '', 'warning')
          }
          this._refresh()
        });
    } else {
      dialog.setAttribute('hidden', true)
    }
  }
}
customElements.define('gasmonitoring-frontend-admin-angebot-ego', AngebotEgo)
